import { CombinedGraphQLErrors, ServerError } from "@apollo/client";

const GqlError = {
  handler,
};

function handler(errorResponse, setErrors) {
  if (CombinedGraphQLErrors.is(errorResponse)) {
    const { errors } = errorResponse;
    const extensions = errors[0]?.extensions;
    if (extensions && !extensions.problems) {
      setErrors(extensions);
    } else {
      setErrors({ gqlError: errors[0].message });
    }
  } else {
    console.error(errorResponse);
    if (ServerError.is(errorResponse)) {
      const { statusCode } = errorResponse;
      if (statusCode === 401) {
        setErrors({ gqlError: "Not logged in" });
      } else if (statusCode >= 400) {
        setErrors({
          gqlError:
            "There was a server error. Please try again. If this problem persists, please contact Nulogy Support.",
        });
      } else {
        setErrors({ gqlError: "Network Error. Is your internet working?" });
      }
    } else {
      throw errorResponse;
    }
  }
}

export default GqlError;
